import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Card, Collapse, Input, Divider, Table, Button, Menu, Col, Row, message, Space, Checkbox, Tab, Carousel } from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";
import { PlusOutlined, DownOutlined, UserOutlined, UpOutlined, HistoryOutlined } from '@ant-design/icons';
import NewTable from "./components/NewTable";
const { Panel } = Collapse;
const AdminCourseOutline = () => {
    const navigate = useNavigate();
    return (<>
        <Row gutter={[8, 8]} justify={'end'}>
            <Col>
                <Button style={{ backgroundColor: '#FdF9C9', display: "inline-flex", alignItems: "center" }} icon={<PlusOutlined />}>新增課程大綱</Button>
            </Col>
            <Col span={24}>
                <Collapse defaultActiveKey={['1']} >
                    <Panel header={<>
                        <Row gutter={16} justify={'space-between'}>
                            <Col>
                                <Row gutter={16} align={'middle'}>
                                    <Col>授課期間：3/1~9/1</Col>
                                    <Divider type="vertical" />
                                    <Col>課程名稱：無框美學</Col>
                                    <Divider type="vertical" />
                                    <Col>授課老師：王小華</Col>
                                </Row>
                            </Col>
                            <Col>
                                <Button style={{ backgroundColor: '#73FAC9', display: "inline-flex", alignItems: "center" }} onClick={e => navigate('/cramSchool/admin/CourseOutlineManage')}>前往課程</Button>
                            </Col>
                        </Row>
                    </>}
                        key="1">
                        <Row gutter={[8, 8]}>
                            <Col span={24}>
                                <p>課程概述</p>
                            </Col>
                            <Col span={24}>
                                <Table columns={[{
                                    title: '週次',
                                    dataIndex: 'week'
                                }, {
                                    title: '內容',
                                    dataIndex: 'content'
                                }, {
                                    title: '教材講義',
                                    dataIndex: 'content'
                                }, {
                                    title: '回家作業',
                                    dataIndex: 'content'
                                }]}></Table>
                            </Col>
                        </Row>
                    </Panel>
                </Collapse>
            </Col>
        </Row >

    </>)
}
export default AdminCourseOutline;